import { LoadingButton } from '@mui/lab';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { LoginForm } from 'app/pages/Login';
import { useAsyncAction } from 'app/services';
import { sessionGetIp, sessionSignIn } from 'app/store/session';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink, Redirect } from 'react-router-dom';
const Login = () => {
    const formRef = useRef(null);
    const { ip, secret } = useSelector((state) => state.session);
    const { asyncAction: submit, isLoading, isError, error } = useAsyncAction(sessionSignIn);
    const { asyncAction: fetchIp } = useAsyncAction(sessionGetIp);
    const handleClickForm = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmitForm();
    };
    const handleSubmitForm = (params) => {
        submit(params.email, params.password);
    };
    const handleLogKey = (e) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            e.preventDefault();
            handleClickForm();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleLogKey);
        return () => {
            document.removeEventListener('keydown', handleLogKey);
        };
    }, []);
    useEffect(() => {
        if (!ip) {
            fetchIp();
        }
    }, []);
    if (secret) {
        if (secret.qr) {
            return React.createElement(Redirect, { to: '/account/setup-2fa' });
        }
        return React.createElement(Redirect, { to: '/account/check-2fa' });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'row', flexDirection: 'column', sx: (theme) => ({
                paddingBottom: theme.spacing(2),
                '.MuiTypography-h5': {
                    marginBottom: theme.spacing(1),
                },
                '.MuiTypography-body2': {
                    color: theme.palette.text.secondary,
                },
            }) },
            React.createElement(Typography, { variant: 'h5' }, "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F"),
            React.createElement(Typography, { variant: 'body2' }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0432\u043E\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443 \u0438 \u043F\u0430\u0440\u043E\u043B\u044C.")),
        React.createElement(LoginForm, { ref: formRef, onSubmit: handleSubmitForm }),
        React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'flex-start', spacing: 2, sx: (theme) => ({
                marginTop: theme.spacing(3),
                '.MuiLoadingButton-root': {
                    lineHeight: '22px',
                    padding: theme.spacing(2),
                },
                '.MuiAlert-root': {
                    width: '100%',
                    marginBottom: theme.spacing(2),
                    borderRadius: theme.shape.borderRadius,
                },
            }) },
            isError && (React.createElement(React.Fragment, null, (error === null || error === void 0 ? void 0 : error.status) === 418 ? (React.createElement(Alert, { severity: 'error' }, "\u0412\u0430\u0448\u0430 \u0443\u0447\u0451\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430. \u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443.")) : (React.createElement(Alert, { severity: 'error' }, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0432\u043E\u0439\u0442\u0438. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043B\u043E\u0433\u0438\u043D\u0430 \u0438 \u043F\u0430\u0440\u043E\u043B\u044F.")))),
            React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                    width: '100%',
                    paddingBottom: theme.spacing(2),
                    '.MuiTypography-body1': {
                        '&:first-of-type': {
                            color: theme.palette.text.secondary,
                        },
                        '&:last-of-type': {
                            marginLeft: '4px',
                        },
                    },
                }) },
                React.createElement(Typography, { variant: 'body1' }, "\u0412\u0430\u0448 IP \u0430\u0434\u0440\u0435\u0441:"),
                React.createElement(Typography, { variant: 'body1' }, ip ? ip : 'Не определен')),
            React.createElement(LoadingButton, { variant: 'contained', loading: isLoading, onClick: handleClickForm, fullWidth: true, disableElevation: true }, "\u0412\u043E\u0439\u0442\u0438"),
            React.createElement(Typography, { variant: 'body2' },
                React.createElement(Link, { to: 'account/forgot', variant: 'subtitle2', underline: 'none', component: RouterLink }, "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?")))));
};
export default Login;
